import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useHistory, useLocation } from "react-router-dom";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { NeokredNewLogo } from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import {
  CLIENT,
  RESELLER,
  DASHBOARD_ACL,
  STATUS_CODE_200,
  VAN_ACL,
} from "../../../../utility/constants/valueConstants";
import { validateEmail } from "../../../../utility/emailValidator";
import ResizeListner from "../../../../utility/ResizeListner";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import CustomPasswordInput from "../../../components/ui_comps/CustomPasswordInput";
import reactpackage from "../../../../../package.json";
import {
  storeAllAcls,
  storeResponseToLocalStorage,
} from "../../../../services/loginService";
import { addToAclList } from "../../../../data/redux/slice/aclSlice";
import { authSliceReducerSlice } from "../../../../data/redux/slice/authSlice";
import { SS_AUTH_TOKEN } from "../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../services/secureStorage";
import ImageComponent from "../ImageComponent";
function Login({ onSuccess }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { height, width } = ResizeListner();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [showVerifiedEmail, setShowVerifiedEmail] = useState(false);
  const [verified, setVerified] = useState("");

  useEffect(() => {
    if (
      password.length >= 12 &&
      password.length <= 16 &&
      email !== "" &&
      passwordValid
    ) {
      setDisabled(false);
    } else setDisabled(true);
    // return () => {};
  }, [password, email, passwordValid]);

  const fecthDetails = (data) => {
    ApiRequestPost.fetchUserDetails({
      role: data?.role,
      userId: data?.userId,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          storeResponseToLocalStorage({
            ...response.data,
            ...data,
            isVerified:
              data.role?.toUpperCase() === CLIENT
                ? response?.data?.isVerified
                : "",
          });

          dispatch(addToAclList(storeAllAcls(data?.aclList)));
          dispatch(authSliceReducerSlice(true));

          const aclValues = data.aclList.map((item) => item?.acl_value);
          const isVanAcl = aclValues.includes(VAN_ACL);
          const isDashboardAcl = aclValues.includes(DASHBOARD_ACL);

          if (isVanAcl && !isDashboardAcl) {
            navigate("/van/dashboard");
          } else {
            navigate("/dashboard");
          }
          enqueueSnackbar("Logged in successfully", {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  const onClickLoginClient = () => {
    setLoading(true);
    ApiRequestPost.loginWithoutOtp({
      email,
      password,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          let Role = response.data.role?.toUpperCase();

          // go to verify 2fa
          if (
            Role !== CLIENT &&
            Role !== RESELLER &&
            response.data.twoFactorEnabled
          ) {
            navigate("/verify", {
              state: { response: response.data },
            });
          } else {
            secureStorage.setItem(SS_AUTH_TOKEN, response?.data?.token);
            fecthDetails(response.data);
          }
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  const checkUser = () => {};
  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      {/* <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colorWhite,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div> */}
      <ImageComponent />
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgColor,
          flexDirection: "column",
          height,
          // backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "400",
              fontSize: 15,
              color: "#2D3748",
              margin: 0,
            }}
            className="roboto"
          >
            Welcome back
          </p>
          <p
            style={{
              fontWeight: "600",
              fontSize: 27,
              marginBottom: 30,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            Login to your account
          </p>
          <div style={{ marginTop: "25px" }}>
            <p style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}>
              Email<span style={{ color: "#FC3629" }}>*</span>
            </p>

            <CustomInput
              type={"input"}
              title="Email"
              value={email}
              placeholder="Enter Email"
              onChange={(data) => {
                setEmail(data);
                if (validateEmail(data)) {
                  checkUser(data);
                } else {
                  setShowVerifiedEmail(false);
                }
              }}
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              validator="email"
              isRightIconRequired={showVerifiedEmail}
              // rightIcon={
              //   <img
              //     src={require("../../../assets/png/animated.gif")}
              //     width={30}
              //     height={30}
              //     alt="Show Verified Email"
              //     style={{}}
              //   />
              // }
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <p style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}>
              Password<span style={{ color: "#FC3629" }}>*</span>
            </p>

            <CustomPasswordInput
              value={password}
              onChange={setPassword}
              placeholder="Enter Password"
              isError={(data) => setPasswordValid(data)}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></div>

            <p
              style={{
                fontSize: 14,
                color: "#3783FB",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/forgotpassword");
              }}
              className="roboto"
            >
              Forgot password?
            </p>
          </div>
          <CustomButton
            loading={loading}
            title="Login"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 15,
              height: "50px",
            }}
            textStyles={{
              color: colorWhite,
              fontSize: 15,
              fontWeight: "500",
            }}
            onClick={() => {
              onClickLoginClient();
            }}
            disabled={disabled}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                onClickLoginClient();
              }
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          position: "absolute",
          bottom: 0,
          right: 0,
          margin: 20,
        }}
      >
        <p
          style={{
            fontSize: 12,
          }}
        >
          Version {reactpackage.version}
        </p>
      </div>
    </div>
  );
}

export default Login;
